<template>
  <div id="online-training">
    <div class="wrapper">
      <mainHeader class="mainHeader"></mainHeader>
      <img :src="bannerImage" />
      <div class="items">
        <img :src="value" class="item" v-for="(value, index) in imgList" :key="index" @click="gotoTraining(index)" />
      </div>
      <img v-for="(value, index) in images" :key="index" v-bind:src="value" />
      <div class="section">
        <div class="video-content">
          <div class="videos">
            <div class="video" v-for="(value, index) in videos" :key="index">
              <div :id="'myVideo' + (index+1)" class="image" v-on:click="playPause(value.video)"
                :style="{backgroundImage:'url('+value.image+')'}"></div>
              <div class="title">{{value.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <mainFooter class="mainFooter"></mainFooter>
    </div>

    <!--弹出播放视频-->
    <div v-show="videoHtml.length>0" class="layer" style="display: none;"></div>
    <div v-show="videoHtml.length>0" class="video-pop" style="display: none;">
      <a href="javascript:;" class="btn-close" @click="closeVideo"></a>
      <div class="video-box" v-html="videoHtml">
      </div>
    </div>
  </div>
</template>
<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'

export default {
  data () {
    return {
      bannerImage: '',
      imgList: [require('../assets/kepu.png'), require('../assets/jinsheng.png'), require('../assets/dingzhi.png')],
      images: [
        require('../assets/icon-training1.png'),
        require('../assets/icon-training2.png'),
        require('../assets/icon-training3.png'),
        require('../assets/icon-training4.png')],
      videos: [
        { 'id': '1', 'title': '装修不要使用易燃材料', 'video': 'http://video.zxzx119.com/6767cfa6e78c4768bba820236a4ddcd8/1ed40d31c75540f090640c25bae223c9-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../assets/icon_video1.jpg') },
        { 'id': '1', 'title': '油锅着火怎么办', 'video': 'http://video.zxzx119.com/b065bec910004ea394e7920b4088635c/5a30bb3fe6ba4183a3aa0e1be7319055-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../assets/icon_video2.jpg') },
        { 'id': '1', 'title': '煨汤无人看管会失火', 'video': 'http://video.zxzx119.com/ec11b55be77e425c96d594fc38be592d/4aaa709346204182a5f4a5ef6a558e8e-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../assets/icon_video3.jpg') },
        { 'id': '1', 'title': '天然气着火怎么办', 'video': 'http://video.zxzx119.com/b4fa1e8ece2f4df7862e3f73afe51bab/c561800fe32a4eefb09a23044599b1a5-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../assets/icon_video4.jpg') }

      ],
      videoHtml: ''
    }
  },
  methods: {
    gotoTraining: function (index) {
      var _this = this
      if (index === 0) {
        this.utils.isUserLogin(function (login) {
          console.log('==========' + login)
          if (login === 1) {
            window.location.href = 'http://www.zxzx119.com/addtrain'
          } else {
            _this.$router.push({ path: 'login', query: { back: 1 } })
          }
        })
      }
    },
    loadBanner: function () { // 获取banner图
      var _this = this
      this.utils.GET(this.accountUrl + '/adb/getList?type=12',
        function (data) {
          let result = data.data[0]
          _this.bannerImage = result.ad_file
        })
    },
    playPause: function (videoUrl) {
      // this.videoHtml = '<video autoplay="autoplay" controls="controls" width="100%" height="100%" loop="loop" preload="auto" src='+ videoUrl +'></video>'
      this.videoHtml = '<video autoplay="autoplay" controls="controls" width="100%" height="100%" loop="loop" preload="auto" src=' + videoUrl + '></video>'
    },
    closeVideo: function () {
      this.videoHtml = ''
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  },
  watch: { // 监测
    $router () {
    }
  },
  mounted () {
    this.loadBanner()
  }

}

</script>

<style scoped>
.wrapper {
  background-color: #f6f6f6;
  width: 100%;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.items {
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 110px;
  background-color: #f1f1f1;

  text-align: center;
}
.items .item {
  width: 28%;
  height: 85px;
  float: left;
  position: relative;
  margin-left: 4%;
  margin-top: 15px;
  background-color: #ebebeb;
}
.items .item img {
  margin-top: 8px;
  margin-left: calc(50% - 12px);
  width: auto;
  height: 24px;
}
.items .item .title {
  margin-top: 2px;
  font-size: 13px;
  color: #000000;
}
.items .item .stitle {
  font-size: 11px;
  color: #808080;
  margin-top: 4px;
  line-height: 12px;
}

img {
  width: 100%;
  display: block;
}
img:first-of-type {
  margin-top: 55px;
}
.section {
  position: relative;
  height: 270px;
  width: 100%;
  background-color: #f1f1f1;
}
.section .video-content {
  position: absolute;
  top: 20px;
  height: 200px;
  width: 100%;
  overflow-x: scroll;
  /*background-color: yellow;*/
}
.section .video-content .videos {
  height: 200px;
  width: 1175px;
  /*width: 100%;*/
}
.section .video-content .videos .video {
  position: relative;
  float: left;
  height: 155px;
  width: 275px;
  margin-left: 15px;
  background-color: #f9f9f9;
}
.section .video-content .videos .video .image {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 275px;
  height: 155px;
  background-color: #f9f9f9;
  /*background-image: url(../assets/icon_video1.jpg);*/
  background-size: cover;
  background-position: center center;
}
.section .video-content .videos .video .title {
  position: absolute;
  top: 170px;
  left: 0px;
  height: 20px;
  line-height: 20px;
  font-size: 15px;
  color: #000000;
}
.mainFooter {
}
</style>



// WEBPACK FOOTER //
// src/view/online-training.vue